/**
 * org level preference for how calendar dates render across the app
 */
export enum OrganizationDateFormat {
  MM_DD_YYYY = "MM_DD_YYYY",
  DD_MM_YYYY = "DD_MM_YYYY",
  YYYY_MM_DD = "YYYY_MM_DD",
}
